import { Modal, ModalBody, ModalFooter, Button, ModalHeader } from 'src/components/ui';
import { Trans } from '@lingui/react/macro';
import { getTestId } from '../../hooks/useTestId';

interface CancelWaiverConfirmationModalProps {
  isOpen: boolean;
  onConfirm: (confirmed: boolean) => void;
  testIdBase?: string;
}

function CancelWaiverConfirmationModal({ isOpen, onConfirm, testIdBase = 'cancel-waiver-modal' }: CancelWaiverConfirmationModalProps) {
  return (
    <Modal isOpen={isOpen} toggle={() => onConfirm(false)} className="modal-primary" size="md" backdrop="static" keyboard={false}>
      <ModalHeader toggle={() => onConfirm(false)}>
        <Trans>Confirm Waiver Cancellation</Trans>
      </ModalHeader>
      <ModalBody>
        <div className="text-center" style={{ paddingBottom: '1rem' }}>
          <Trans>Are you sure you want to cancel this waiver? This action is irreversible.</Trans>
        </div>
        <div className="text-center">
          <Trans>
            After confirming: The status of the waiver will be Cancelled, the system will notify all affected institutions, and the institutions will
            receive the details and original due date that applies to them.
          </Trans>
        </div>
      </ModalBody>
      <ModalFooter className="justify-center">
        <Button color="danger" onClick={() => onConfirm(true)} {...getTestId(testIdBase, '.', 'confirm')}>
          <Trans>Yes, cancel waiver</Trans>
        </Button>
        <Button color="secondary" onClick={() => onConfirm(false)} {...getTestId(testIdBase, '.', 'cancel')}>
          <Trans>No, return</Trans>
        </Button>
      </ModalFooter>
    </Modal>
  );
}

export default CancelWaiverConfirmationModal;
